import { execSafeSaga } from '@lib/helpers';
import { all, call, takeEvery, put } from 'redux-saga/effects';
import { actionType } from './action';
import { IAction } from '@interface/IAction';
import {
    createFunderStatement,
    getFunderStatementUrl,
} from './report.service';
import {
    setPreSignedFunderStatementUrl,
} from './action';
import { IFunderStatement } from '@/interface/report/FunderStatement';

function* createFunderStatementSaga(action: IAction) {
    const {
        beginDate,
        endDate,
        balanceOffsetUSD,
        balanceOffsetHKD,
        creator,
        setIsSendingCreateFunderStatementRequest,
    } = action.payload;
    yield execSafeSaga(function*() {
        const report: IFunderStatement = yield call(createFunderStatement, { beginDate, endDate, balanceOffsetHKD, balanceOffsetUSD, creator });
        const url = yield call(getFunderStatementUrl, report.path); // Get pre-signed url to download file
        yield put(setPreSignedFunderStatementUrl(url));
        setIsSendingCreateFunderStatementRequest(false);
    });
}

function* rootSaga() {
    yield all([
        takeEvery(actionType.CREATE_FUNDER_STATEMENT, createFunderStatementSaga),
    ]);
}

export default rootSaga;
